module.exports = __webpack_public_path__ + "img/2018nianhui.18011670.png";